import request from '@/utils/service'

export function getTools(data, locale) {
  return request({ url: 'tool/list', data, locale })
}

export function updateTool(data, locale) {
  return request({ url: 'tool/save', data, locale })
}

export function deleteTool(id, locale) {
  return request({ url: `tool/delete/${id}`, locale })
}

export function reUpdateTool(id, locale) {
  return request({ url: `tool/re-update-summary/${id}`, locale })
}

export function saveToolFromUrl(url, locale) {
  return request({ url: `tool/saveFromUrl?url=${url}`, data: {}, locale })
}

export function saveToolFromContent(data, locale) {
  return request({ url: 'tool/saveFromContent', data, locale })
}

export function getLearnings(data, locale) {
  return request({ url: 'learn/list', data, locale })
}

export function updateLearning(data, locale) {
  return request({ url: 'learn/save', data, locale })
}

export function deleteLearning(id, locale) {
  return request({ url: `learn/delete/${id}`, locale })
}

export function reUpdateLearning(id, locale) {
  return request({ url: `learn/re-update-summary/${id}`, locale })
}

export function saveLearningFromUrl(url, locale) {
  return request({ url: `learn/saveFromUrl?url=${url}`, data: {}, locale })
}
